import { Component, OnInit } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { environment } from 'environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.sass'],
  imports: [NgOptimizedImage],
  standalone: true,
})
export class WidgetComponent implements OnInit {

  userName: string = '';

  text: string = 'Get Started';

  themeColor: string = '#f25a21';

  buttonUrl: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(
        untilDestroyed(this),
      )
      .subscribe((params: Params) => {
        const { user, partner, text, hex } = params;

        if (user) this.userName = user;

        if (text) this.text = text;

        if (hex) this.themeColor = `#${hex}`;

        const partnerQueryParams: string = partner ? `?partner=${encodeURI(partner)}` : '';

        this.buttonUrl = `${environment.appUrl}/${encodeURI(this.userName)}/stepper${partnerQueryParams}`;
      });
  }

}
